<template>
  <div class="tickBox">
    <el-row>
      <el-col :span="24" class="tickMid">
        <el-col :span="12" class="mma"> 消息群发 </el-col>
      </el-col>
    </el-row>
    <el-row>
      <!-- <el-col :span="24" class="formBox">
        <span class="spanfont"> 用户账号 </span>
        <div class="radioBox">
          <el-input
            v-model="phoneValue"
            placeholder="请输入用户账号"
          ></el-input>
        </div>
        <div class="radioBox">
          <el-button type="primary" plain class="butsOne" @click="handleReset"
            >重置</el-button
          >
          <el-button type="primary" class="butsTwo" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </el-col> -->
      <el-col :span="24" v-loading="loading" class="tabBox">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column width="120" prop="xh" label="序号"> </el-table-column>
          <el-table-column prop="agreementUrl" label="消息内容">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.agreementUrl"
                placement="top"
              >
                <span>{{ scope.row.agreementUrl }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="140" prop="Bcompany_name" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="handleGoods(scope.row)">群发推送</el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-col>
      <!-- <el-col :span="24" class="pageBox">
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="nowpage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagelist"
            :total="this.totalPage"
          >
          </el-pagination>
        </div>
      </el-col> -->
    </el-row>
    <!-- 修改密码弹框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="PasswordDailog"
      width="35%"
      @close="closePasswordDailog"
    >
      <el-form ref="formPassword" :model="formPassword" label-width="100px">
        <el-form-item label="新密码">
          <el-input v-model="formPassword.newpassword"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="formPassword.confirmnewpassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="PasswordDailog = false">取 消</el-button>
        <el-button type="primary" @click="submitPassword">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看商品 -->
    <el-dialog
      title="商品"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
          <el-table :data="goodList">
            <el-table-column
              align="center"
              prop="pic"
              label="图片"
              >
              <template slot-scope="scope">
                <img :src="scope.row.pic" width="150px">
              </template>
            </el-table-column>
            <el-table-column
              prop="duedateStr"
              label="到期日期"
              align="center">
            </el-table-column>
          </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Vue from "vue";

export default {
  data() {
    return {
      dialogVisible:false,
      nowpage: 1,
      pagelist: 10,
      loading: true,
      codeValue: "",
      phoneValue: "",
      timeValue: [],
      value1: [],
      input: "",
      tableData: [],
      value: "",
      total: 100,
      pageSize: "1",
      comValue: "",
      status: "",
      totalPage: 0,
      show: false,
      shows: false,
      names: "",
      name: "",
      vals: "",
      radio3: "",
      mobile: "",
      fileList: [],
      goodList:[],
      PasswordDailog: false, //修改密码弹框
      formPassword: { mobile: "" } //修改密码对象
    };
  },
  mounted() {
    this.handleAjax();
  },
  methods: {
    UploadUrl: function(val) {
      return "https://api.with-ex.net/address/importaddress?uid=" + val;
    },
    deleteUser: function(val) {
      console.log(val);
      let bizContent = {};
      bizContent.id = val.id;
      this.ajax
        .post(this.versatile.withurl + "/user/deleteuser", { bizContent })
        .then(result => {
          if (result.data.status === "0000") {
            this.$message({
              message: "删除成功",
              showClose: true,
              type: "success"
            });
            this.handleAjax();
          }
        });
    },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(
    //     `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
    //       files.length + fileList.length
    //     } 个文件`
    //   );
    // },
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    handsuccess() {
      this.$message({
        message: "恭喜你，上传成功",
        type: "success"
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    DownloadUrl(val) {
      console.log(val.id);
      let that = this;
      let bizContent = {};
      bizContent.uid = val.id;
      this.ajax
        .post(this.versatile.withurl + "/address/addressList", { bizContent })
        .then(res => {
          console.log(res.data.data);
          if (res.data.data != null) {
            this.tablist = res.data.data;
            require.ensure([], () => {
              const {
                export_json_to_excel
              } = require("../../vendor/Export2Excel");
              // 对应表格输出的title
              const tHeader = [
                "地址类型(1:寄件地址;2:收件地址)",
                "姓名",
                "联系手机",
                "公司名称",
                "地址",
                "城市",
                "邮编",
                "国家",
                "邮箱",
                "收件方税号"
              ];
              // 对应表格输出的数据
              const filterVal = [
                "addtype",
                "name",
                "tel",
                "cmpname",
                "address",
                "city",
                "postcode",
                "country",
                "emial",
                "taxno"
              ];
              // const list = this.tablist;
              console.log(that.tablist, data);
              const data = this.formatJson(filterVal, that.tablist);
              // 对应下载文件的名字
              export_json_to_excel(tHeader, data, "用户地址管理");
            });
          } else {
            this.$message({
              message: "该用户尚未导入常用地址",
              showClose: true,
              type: "error"
            });
          }
        });
    },

    handleExcel() {
      let that = this;
      console.log(this);
      let bizContent = {};
      bizContent.mobile = this.phoneValue;
      bizContent.name = this.name;
      this.ajax
        .post(this.versatile.withurl + "/user/userListExport", { bizContent })
        .then(res => {
          console.log(res.data.data);
          this.tablist = res.data.data;
          require.ensure([], () => {
            const {
              export_json_to_excel
            } = require("../../vendor/Export2Excel");
            // 对应表格输出的title
            const tHeader = [
              "序号",
              "用户账号",
              "用户昵称",
              "注册时间",
              "注册类型(1:公司;2:个人)",
              "证件信息"
            ];
            // 对应表格输出的数据
            const filterVal = [
              "id",
              "mobile",
              "name",
              "stringCreateTime",
              "certificatetype",
              "businessimg"
            ];
            // const list = this.tablist;
            console.log(that.tablist);
            const data = this.formatJson(filterVal, that.tablist);
            // 对应下载文件的名字
            export_json_to_excel(tHeader, data, "用户管理");
          });
        });
    },

    handleCurrentChange(val) {
      this.nowpage = val;
      this.handleAjax();
    },

    handleAjax() {
      this.loading = true;
      let bizContent = {};
      // bizContent.merchant=''
      // bizContent.partner=this.codeValue
      //bizContent.mobile = this.phoneValue;
      // bizContent.name = this.name;
      //bizContent.pageNum=this.pageSize

      bizContent.currentPage = this.nowpage;
      bizContent.pageSize = "10";
      // bizContent.comValue = this.comValue;
      // bizContent.codeValue = this.codeValue;
      // bizContent.uid = "";
      // bizContent.status = this.radio3;
      // bizContent.status = this.status;
      // if(this.timeValue.length!=0){
      //     bizContent.begindate=this.timeValue[0]
      //     bizContent.enddate=this.timeValue[1]
      // }else{
      //     bizContent.begindate=''
      //     bizContent.enddate=''
      // }
      // if(this.value1.length!=0){
      //     bizContent.billbegindate=this.value1[0]
      //     bizContent.billenddate=this.value1[1]
      // }else{
      //     bizContent.billbegindate=''
      //     bizContent.billenddate=''
      // }
      this.ajax
        // .post("http://47.99.157.156:33100/auth/pageList", { bizContent })
        .post("https://api.andarm.com.cn/message/messageList", { bizContent })
        .then(result => {
          // console.log(result)
          if (result.data.status == "0000") {
            let arr = result.data.data;
            //this.totalPage = result.data.data.total;
            console.log(result.data.data);
            // result.data.data.data.data.forEach(item => {
            //   console.log(item);
            //   if (item.status === "100") {
            //     Vue.set(item, "statustype", "待收货");
            //   } else if (item.status === "200") {
            //     Vue.set(item, "statustype", "已完成");
            //   } else if (item.status === "300") {
            //     Vue.set(item, "statustype", "已取消");
            //   }
            // });
            arr.map((it, index) => {
              it.xh = index + 1;
            });
            this.tableData = arr;
            //this.total = result.data.data.total;
            this.loading = false;
          } else {
            this.$message(result.data.message);
          }
        });
    },
    handleChangePage(val) {
      this.pageSize = val;
      this.handleAjax();
    },
    handleClick(row) {
      this.$router.push({
        path: "/mentMonInfor",
        query: {
          id: row.Buid,
          code: row.Borganization_code
        }
      });
    },
    handleChangeTime() {},
    handleReset() {
      this.phoneValue = "";
      this.name = "";
      // this.stateValue = "";
      // this.phoneValue=''
      // this.timeValue=[]
      // this.value1=[]
    },
    handleSearch() {
      // console.log(this.comValue, this.codeValue, this.stateValue);
      this.phoneValue = this.phoneValue;
      this.handleAjax();
    },
    handleRowClick(val) {
      console.log(val);
      this.$router.push({
        name: "ControlInfo",
        query: {
          mobile: val.mobile,
          uid: val.id
        }
      });
    },
    showlist() {
      this.show = !this.show;
    },
    cancellation(val) {
      console.log(val);
      let bizContent = {};
      bizContent.orderId = val;
      bizContent.status = "300";
      this.ajax.post(this.versatile.withurl + "/order/changeorder", {
        bizContent
      });
      this.show = !this.show;
    },
    finish(val) {
      console.log(val);
      let bizContent = {};
      bizContent.orderId = val;
      bizContent.status = "200";
      this.ajax.post(this.versatile.withurl + "/order/changeorder", {
        bizContent
      });
      this.show = !this.show;
    },
    alter(val) {
      console.log(val);
      this.names = val.orderId;
      this.vals = val.changeid;
      this.shows = !this.shows;
    },
    clipboardSuccessHandler({ value, event }) {
      this.$message({
        message: "复制成功",
        showClose: true,
        type: "success"
      });
      console.log("success", value, event);
    },

    clipboardErrorHandler({ value, event }) {
      this.$message({
        message: "复制失败",
        showClose: true,
        type: "error"
      });
      console.log("error", value);
    },

    changeClick() {
      this.ajax
        .post(this.versatile.withurl + "/order/changeno", {
          bizContent: { orderId: this.names, changeno: this.vals }
        })
        .then(result => {
          if (result.data.status == "0000") {
            swal({
              text: "修改成功！",
              timer: 3000,
              buttons: false
            });
            this.shows = false;
            this.handleAjax();
          } else {
            swal({
              text: result.data.message,
              timer: 3000,
              buttons: false
            });
          }
        });
    },
    handleRadioChange(val) {
      this.handleAjax();
    },
    showText(val) {
      console.log(val);
    },
    //修改密码按钮弹框
    changePassword(row) {
      this.PasswordDailog = true;
      console.log(row);
      this.formPassword.mobile = row.mobile;
    },
    //确认修改密码提交
    submitPassword() {
      console.log(this.formPassword);
      this.ajax
        .post(this.versatile.withurl + "/auth/changepasword", {
          bizContent: {
            newpassword: this.formPassword.newpassword,
            confirmnewpassword: this.formPassword.confirmnewpassword,
            mobile: this.formPassword.mobile
          }
        })
        .then(result => {
          this.$message.success("修改密码成功!");
          this.PasswordDailog = false;
          this.handleAjax();
        });
    },
    closePasswordDailog() {
      this.formPassword = { mobile: "" };
    },
    handleGoods(val){
      //this.dialogVisible=true;
      //let bizContent=[]
      //bizContent.id = val.id;
      //bizContent.pageSize = "10";
      console.log(val.id);
       this.ajax
        //.post("http://47.99.157.156:33100/goods/pageList", { bizContent:{currentPage:'1',pageSize:'10',phone:val.mobile} })
         .post("https://api.andarm.com.cn/goods/messagepush", { bizContent:{"id":val.id}})
        .then(result => {
          console.log('结果:')
          console.log(result)
          if(result.status==200){
            this.$message({
              message: "消息推送成功",
              showClose: true,
              type: "success"
            });
          }
        });
    },
    handleClose(){
      this.dialogVisible=false;
    }
  }
};
</script>

<style scoped>
.other {
  position: absolute;
}
.tickBox {
  margin-left: 20px;
}
.tickMid {
  margin-top: 10px;
  width: 100%;
  background: #fff;
  height: 55px;
  line-height: 50px;
  text-align: left;
  padding: 10px 15px;
}
.mma {
  font-size: 24px;
  padding-left: 10px;
}
.rigrig {
  text-align: right;
}
.formBox {
  padding: 20px 5px 20px 15px;
  background: #fff;
  /* border: 2px solid #eee;
    box-shadow: 2px 2px 4px #eee; */
  /* margin: 10px 0; */
}
.alls {
  margin-top: 20px;
}
.radioBox {
  height: 40px;
  line-height: 40px;
  margin-right: 10px;
  display: inline-block;
  margin-bottom: 10px;
}
.radioBox >>> .el-input__inner {
  width: 224px;
}
.selBox {
  margin-right: 20px;
}

.butsOne {
  width: 74px;
  height: 30px;
  padding: 0;
}
.butsTwo {
  width: 74px;
  height: 30px;
  padding: 0;
  margin-right: 20px;
}
.spanfont {
  height: 40px;
  width: 70px;
  display: inline-block;
  text-align: right;
  line-height: 40px;
  margin-right: 5px;
  margin-left: 5px;
  color: #333333;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
}
.pickBox > .el-input__inner {
  width: 305px;
}
.tabBox {
  /* min-height: 720px; */
  background: #fff;
  padding: 0 20px;
}
/* .tabBox>>>.el-table__empty-text{
    min-height: 360px;
    line-height: 360px;
} */
.tabBox >>> .el-table__body-wrapper {
  min-height: 710px;
  overflow-y: auto;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.tabBox >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.pageBox {
  text-align: center;
  margin: 20px 0;
}
</style>
<style>
.el-upload-list {
  display: none;
}

.cell{
  white-space: normal!important;
}

</style>



// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/sendcontrol.vue